import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../hooks/useAuth";

const SHARED = ["/stand-easy", "/practices", "/networker/resets", "/my-journeys", "/my-library", "/voice-clone", "/signature-installations", "/account"];
const KEY = "se_ctx";

// Stand Easy context: entered at /stand-easy, kept while on shared screens, dropped anywhere else.
export function standEasyActive(path, user) {
  const shared = SHARED.some((p) => path === p || path.startsWith(`${p}/`));
  if (path.startsWith("/stand-easy")) sessionStorage.setItem(KEY, "1");
  else if (!shared) sessionStorage.removeItem(KEY);
  return shared && (user?.access_scope === "stand_easy_tester" || sessionStorage.getItem(KEY) === "1");
}

// Keeps shared screens in the Stand Easy greens (body.se-skin in index.css) and offers a way home.
export function StandEasySkin() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const nav = useNavigate();
  const active = standEasyActive(pathname, user);
  useEffect(() => {
    document.body.classList.toggle("se-skin", active);
    return () => document.body.classList.remove("se-skin");
  }, [active]);
  if (!active || pathname.startsWith("/stand-easy")) return null;
  return (
    <button type="button" onClick={() => nav("/stand-easy")} data-testid="se-return-pill"
      className="fixed left-4 z-[200] inline-flex items-center gap-2 rounded-full px-4 py-2.5 text-[12px] font-medium backdrop-blur-xl transition-opacity hover:opacity-90"
      style={{ bottom: "calc(16px + env(safe-area-inset-bottom, 0px))", background: "rgba(29,42,31,0.88)", border: "1px solid rgba(201,211,168,0.3)", color: "#D9CFBC" }}>
      <ArrowLeft size={14} /> Stand Easy
    </button>
  );
}
